export default "__VITE_ASSET__Bjx1RELi__"